import { get } from 'lodash-es';
import { createSelector } from 'reselect';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectBatchNumber = (state) => get(state, 'batchNumber');
const selectShipStationColsRaw = (state) => get(state, 'shipStationCols', emptyArray);
export const selectShipStationCols = createSelector(selectShipStationColsRaw, (columns) =>
  [...columns].sort((columnA, columnB) => (columnA.name < columnB.name ? -1 : 1)),
);
export const selectImportedCols = (state) => get(state, 'importedCols');
export const selectMappings = (state) => get(state, 'mappings');
export const selectMappingName = (state) => get(state, 'mappingName');
export const selectMappingModalId = (state) => get(state, 'mappingModalId');
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectLog = (state) => get(state, 'importLog');
export const selectImportProgressNotificationId = (state) => get(state, 'importProgressNotificationId');

export const selectSelectedStoreGuid = (state) => get(state, 'storeGuid');
export const selectSelectedStore = (state, stores) => {
  const storeGuid = selectSelectedStoreGuid(state);
  if (!storeGuid) {
    return;
  }

  return stores.find((store) => store.storeGuid === storeGuid);
};
